export const environment = {
  PAYPAL_CLIENT_ID: 'Ad4iOpDwjsp5eYtYOJqTaiE9qWGBoShMToODFvOaXKlGI7VIUWBdBNuYb9zs42gInZ-MVh-Mqqqc8WYd',
  production: false,
  local: false,
  serverApi: 'https://qr.dev.photoseller.me/',
  baseUrl: 'https://test.photoseller.me/',
  firebaseConfig: {
    apiKey: 'AIzaSyCxpsUYmAwxeU3q6N-jt8NU2g04sIPBFws',
    authDomain: 'photo-seller-87304.firebaseapp.com',
    databaseURL: 'https://photo-seller-87304-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'photo-seller-87304',
    storageBucket: 'photo-seller-87304.appspot.com',
    messagingSenderId: '950612631913',
    appId: '1:950612631913:web:76d4425c953e51843addf8',
    measurementId: 'G-5P4PQDKDCE',
  },
  company: {
    name: 'NENASAL LLC',
    address: {
      street: '1007 N Orange',
      suite: '1268',
      city: 'Wilmington',
      state: 'Delaware',
      zip: '19801',
      country: 'United States',
    },
    email: 'office@photoseller.me',
  },
  recaptcha: {
    siteKey: '6LdYqEYqAAAAAEtWl5L6V0FxaCL7389ifhs3kSID',
  },
};
